const adminPermissionFilter = (permission: string) => {
    const permissions = localStorage.getItem('permissions')
    if(JSON.parse(permissions!).includes(permission)){
        return true
    } else {
        return false
    }
}

export default adminPermissionFilter